export const SPILL_ID = 'spill_id';
export const REPORTABLE_SPILL_TYPE = 'Reportable';
export const NON_REPORTABLE_SPILL_TYPE = 'Non-Reportable';
export const HISTORICAL_SPILL_TYPE = 'Historical';
export const RECENT_SPILL_TYPE = 'Recent';
